import React, { useState, useEffect } from 'react';
import { TreeSelect } from 'antd';
import $pais from '@/apis';

function SelectorTreeOrganization(props) {
  const { value = [], onChange, ..._props } = props;
  // 根code是 00000000
  // 原始数据是
  // {
  //  "organizationCode":部门code
  //  "isLeaf": 是否是叶子节点，0-非，1-是*/
  //  "name":部门名称
  // }
  // 需要编程的数据
  // { id: 1, pId: 0, value: '1', title: '', titlePath: 'a' }
  // { id: 3, pId: 0, value: '3', title: '', titlePath: 'c', isLeaf: true }
  const [treeData, setTreeData] = useState([
    // {
    //   pId: '00000000', // 上一个organizationCode
    //   id: '00000000/111111', // organizationCode 就是 id
    //   title: 'Bumenmingcheng0', // organizationName 就是
    //   value: '00000000/111111', // 多个organizationCode拼接起来
    //   titlePath: 'Bumenmingcheng0', // 多个organizationName拼接起来
    //   isLeaf: false // ，0-非，1-是 * /,
    // },
  ]);

  useEffect(() => {
    let mounted = true;
    // 父组织code  注意，京东集团根级编码为00000000
    $pais.queryOrganization('00000000').then((res) => {
      if (!mounted) return;
      const dataFormBackEnd = res.data.organizationTree.map((item) => transformResult(item, '/00000000', ''));
      setTreeData(dataFormBackEnd);
    });

    return () => (mounted = false);
  }, []);

  // 加载部门树
  const onLoadData = (treeNode) => {
    const { id, titlePath, rawId } = treeNode;

    return $pais.queryOrganization(rawId).then((res) => {
      const dataFormBackEnd = res.data.organizationTree.map((item) => transformResult(item, id, titlePath));

      setTreeData([...treeData, ...dataFormBackEnd]);
    });
  };

  const onSelectTreeChange = (selectedValue, label, extra) => {
    const _mapSelectedValue = {};
    // 被选中的值
    selectedValue.forEach((item) => {
      _mapSelectedValue[item] = true;
    });

    const _cachedValue = {};
    value.map((item) => {
      // 只有被选中的才会存在
      if (_mapSelectedValue[item.organization]) _cachedValue[item.organization] = item;
    });

    const curValues = [];
    treeData.forEach((item) => {
      // 重用原来的对象
      if (_cachedValue[item.value]) {
        curValues.push(_cachedValue[item.value]);
      } else if (_mapSelectedValue[item.value]) {
        // 处理id 原来就有的id
        curValues.push({
          id: null,
          organization: item.value,
          organizationName: item.titlePath,
        });
      }
    });

    onChange(curValues);
  };

  return (
    <TreeSelect
      autoClearSearchValue
      maxTagPlaceholder={() => '已选择'}
      treeCheckable
      placeholder="请选择部门"
      treeDataSimpleMode
      style={{ width: '100%' }}
      {..._props}
      value={value.map((item) => item.organization)}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      onChange={onSelectTreeChange}
      loadData={onLoadData}
      treeData={treeData}
    />
  );
}

function transformResult(item, pId, titlePath) {
  return {
    rawId: item.organizationId,
    id: `${pId}/${item.organizationId}`,
    pId: pId,
    value: `${pId}/${item.organizationId}`,
    title: titlePath ? `${titlePath}-${item.name}` : item.name,
    isLeaf: !!item.isLeaf,
    titlePath: titlePath ? `${titlePath}-${item.name}` : item.name,
  };
}

export default SelectorTreeOrganization;
